// ── Scroll reveal (IntersectionObserver) ─────────────────
document.addEventListener('DOMContentLoaded', function () {
  var els = Array.from(document.querySelectorAll('.reveal'));
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.08 }
  );
  els.forEach(function (el) { io.observe(el); });
});
